export default {"src":"/_next/static/media/business3.a2d53b11.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};